import { TranslationKey, useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IWorkspaceSubmitButtonProps {
  label: TranslationKey;
  disabled: boolean;
  onSubmit: () => Promise<void>;
}

export const WorkspaceSubmitButton = observer((props: IWorkspaceSubmitButtonProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <Button
      disabled={props.disabled}
      onClick={() => {
        void props.onSubmit();
      }}
    >
      {t(props.label)}
    </Button>
  );
});
